import { createContext } from "react"

const ThemeContext = createContext({
    selectedTheme: "",
    setSelectedTheme: () => { }
});

export default ThemeContext;